import { MuiDropdown } from '../common/Mui/Dropdown/MuiDropdown';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';
import PropTypes from 'prop-types';

export const CopyVersionDropdown = ({ className, style, inputLabel, labelId, dropdownVariant, dropdownValue, onChange, options, disabled }) => {
  return (
    <div className={className} style={style}>
      <MuiDropdown
        inputLabel={inputLabel}
        labelId={labelId}
        dropdownVariant={dropdownVariant}
        dropdownValue={dropdownValue}
        onChange={onChange}
        options={options.map((period, i) => (
          <MenuItem key={i} value={period.name}>
            {period.name}
          </MenuItem>
        ))}
        disabled={disabled}
      />
    </div>
  );
};

CopyVersionDropdown.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  inputLabel: PropTypes.string,
  labelId: PropTypes.string,
  dropdownVariant: PropTypes.string,
  dropdownValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  options: PropTypes.array,
  disabled: PropTypes.bool,
};